import {
	LODGING_OPTIONS,
	LodgingProviderTypeEnum,
	PAGE_TYPE_ENUM_SELECT_LODGING_MAP,
	ROUTERS,
} from '@/constant';
import { memo } from 'react';

import Button from '../common/button';
import FilterWithViewAll from '../common/filter-with-view-all';
import Modal from '../common/modal';
import Table from '../common/table';
import { ColumnTypes } from '../common/table/type';
import { useLogic } from './select-lodging-modal.logic';
import { IProps } from './select-lodging-modal.type';

const SelectLodgingModal = (props: IProps) => {
	const { title = '숙소 선택', object, providerTable, ...rest } = props;

	const {
		filterRef,
		initialValues,
		columns,
		dataSource,
		rowSelection,
		openModal,
		isWorkerPublicAdminRole,
		fetching,

		fetchData,
		onToggle,
		onCheckIfExists,
		onNavigateLodging,
	} = useLogic(props);

	return (
		<Modal onCancel={onToggle} title={title} {...rest} open={openModal}>
			<div className="flex justify-between">
				<div className="mb-10 flex gap-3">
					<p className="text-[14px] font-bold">
						{PAGE_TYPE_ENUM_SELECT_LODGING_MAP[providerTable]}
					</p>
					{!!object && <p className="text-[13px] font-medium">{object} </p>}
				</div>
			</div>
			<div className="mb-10 flex items-center gap-5">
				<p className="text-[14px] font-bold">숙소 등록</p>
				{!isWorkerPublicAdminRole && (
					<Button
						onClick={onNavigateLodging}
						secondary
						name="register"
						className="!bg-blue11 !text-white rounded-none !border-none"
					>
						숙소 등록
					</Button>
				)}
			</div>

			<p className="text-[14px] font-bold mb-3">숙소 선택</p>
			<div className="mb-5 flex ">
				<FilterWithViewAll
					ref={filterRef}
					initialValues={initialValues}
					rowSelection={rowSelection}
					fetchData={fetchData}
					inputName="searchValue"
					inputPlaceholder=""
					inputClassName="w-[376px]"
					buttonClassName="w-[60px] min-w-0"
					hidePageSize
					isClickSearch
					ignoreCheckAllKeys={['searchType']}
					isShowAutoComplete
					autoCompleteProps={{
						inputClassName: '!w-[375px]',
						containerClassName: 'w-auto',
						options: LODGING_OPTIONS,
					}}
				>
					<FilterWithViewAll.SelectMasterInfo
						defaultValue={LodgingProviderTypeEnum.ADDRESS}
						options={LODGING_OPTIONS}
						name="searchType"
						containerClassName="w-[200px]"
					/>
				</FilterWithViewAll>
			</div>

			<Table
				columns={columns as ColumnTypes}
				dataSource={dataSource}
				rowSelection={{ ...rowSelection }}
				rowKey={'id'}
				pagination={false}
				editable
				scroll={{ y: 400 }}
				loading={fetching}
				toDetailPathName={isWorkerPublicAdminRole ? '' : ROUTERS.LM1_03}
				isSearching={filterRef?.current?.isSearching}
			/>

			<Button
				type="primary"
				className="mt-8 mx-auto block"
				onClick={onCheckIfExists}
				isMainBtn
			>
				저장
			</Button>
		</Modal>
	);
};

export default memo(SelectLodgingModal);
